import spiderman from '@/spiderman/index';

async function verify(deviceToken) {
  return (
    await spiderman.axios.post(spiderman.api.auth, {
      deviceToken,
    })
  ).data;
}

export default {
  verify,
};
